import * as React from 'react';
const Landing = () => <p>Logged in Landing page</p>;
export default Landing;
